import { c as _c } from "react/compiler-runtime";
import { createMutationFn } from '../../../../lib/entry.js';
import { useMutation } from '../../../../tanstack/entry.js';
import { getQuickPick } from '../../../actions/quickpick/entry.js';
const mutationFn = createMutationFn(getQuickPick);
/**
 * A custom hook that provides a mutation for fetching quick pick data.
 *
 * @returns The mutation result object.
 */
export function useGetQuickPick() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}